__turbopack_context__.v({
  "container": "Container-module__uRii6G__container",
  "margin": "Container-module__uRii6G__margin",
});
